export default {"src":"/_next/static/media/pen-doc.5bfaf0c5.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};